import React, {useContext} from 'react';
import PropTypes from 'prop-types';
import { Col, Pagination, PaginationItem, PaginationLink, Row } from 'reactstrap';
import { getPageSlices, MIN_PAGE_NUMBER } from '../utils';
import DataTableContext from "../../../context/DataTableContext";

const TablePagination = (props) => {
  const dataTableContext = useContext(DataTableContext);
  const { currentPage, datasourceSize, pageSize, totalElements } = props;
  const totalPages = Math.ceil(totalElements / pageSize) || 1;

  const changeCurrentPage = (page) => {
    if (page < MIN_PAGE_NUMBER) return;
    if (page > totalPages) return;

    dataTableContext.updateDatasource({ page, pageSize });
  };

  const paginationMessage = () => {
    const slices = getPageSlices(currentPage, pageSize, datasourceSize);
    const from = slices.start + 1;
    const to = slices.end > datasourceSize ? datasourceSize : slices.end;

    return datasourceSize > 0 ? `Exibindo itens do ${from} ao ${to} de ${totalElements}` : '';
  };

  const createPageItem = () => {
    return [...Array(totalPages).keys()]
      .map((pageNumber) => pageNumber + 1)
      .map((pageNumber) => {
        return (
          <PaginationItem
            key={pageNumber}
            active={currentPage === pageNumber}
            onClick={() => dataTableContext.updateDatasource({page: pageNumber, pageSize})}>
            <PaginationLink>
              {pageNumber}
            </PaginationLink>
          </PaginationItem>
        );
      });
  };

  return (
    <Row>
      <Col xs="6">
        <span>{paginationMessage()}</span>
      </Col>
      <Col xs="6">
        <Pagination className="table-pagination" size="sm" aria-label="Table navigation">
          <PaginationItem>
            <PaginationLink
              first
              onClick={() => changeCurrentPage(1)} />
          </PaginationItem>
          <PaginationItem>
            <PaginationLink
              previous
              onClick={() => changeCurrentPage(currentPage - 1)} />
          </PaginationItem>

          {createPageItem()}

          <PaginationItem>
            <PaginationLink
              next
              onClick={() => changeCurrentPage(currentPage + 1)} />
          </PaginationItem>
          <PaginationItem>
            <PaginationLink
              last
              onClick={() => changeCurrentPage(totalPages)} />
          </PaginationItem>
        </Pagination>
      </Col>
    </Row>
  );
};

TablePagination.propTypes = {
  datasourceSize: PropTypes.number.isRequired,
  totalElements: PropTypes.number.isRequired,
  currentPage: PropTypes.number.isRequired,
  pageSize: PropTypes.number.isRequired
};

export default TablePagination;
